var React = require('react');

function Impact (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M10.8904 1.22684V22.7732C10.8904 23.5549 10.1764 24.1412 9.42621 23.9702C4.01733 22.7487 0 17.8507 0 12C0 6.14927 4.01733 1.25127 9.42621 0.0298243C10.1764 -0.141178 10.8904 0.445116 10.8904 1.22684ZM13.3467 1.22684V9.54489C13.3467 10.2167 13.8913 10.7663 14.5568 10.7663H22.773C23.5474 10.7663 24.1282 10.0457 23.9588 9.27617C22.9303 4.68354 19.3606 1.06805 14.823 0.0298243C14.0607 -0.141178 13.3467 0.445116 13.3467 1.22684ZM13.3467 14.4551V22.7732C13.3467 23.5549 14.0607 24.1412 14.823 23.9702C19.3727 22.9319 22.9424 19.3043 23.9709 14.7116C24.1403 13.9543 23.5474 13.2214 22.7851 13.2214H14.5689C13.8913 13.2337 13.3467 13.7833 13.3467 14.4551Z"}));
}

Impact.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = Impact;

Impact.default = Impact;
